import { useSearchParams } from 'react-router-dom';
import { BUSINESS_QUERY_PARAM } from '@/modules/common/constants/search-params.ts';

export const useGetCurrentBusinessId = (): number | null => {
  const [params] = useSearchParams();
  const idParam = params.get(BUSINESS_QUERY_PARAM);
  return idParam && !isNaN(+idParam) && +idParam > 0 ? +idParam : null;
};
